import { useAuth } from "../contexts/FirebaseAuthContext";

/**
 * Hook to check if the current user needs to verify their email.
 * Returns { needsVerification: boolean }
 * 
 * Logic:
 * - Anonymous users (no user) -> false
 * - Google users -> false (verified by Google)
 * - Email/Password users with unverified email -> true
 */
export const useVerificationCheck = () => {
    const { user } = useAuth();
    
    // Anonymous users (not logged in) don't need verification
    if (!user) return { needsVerification: false };

    // Email/Password users with unverified email need verification
    // Google users have emailVerified = true by default, so they skip this
    const needsVerification = !user.emailVerified && !user.isGoogleUser;

    return { needsVerification };
};
